/** Coerce API / PostgreSQL text[] values to a string array safe for `.join()`. */
export function textArray(value: unknown): readonly string[] {
  if (value == null) return [];
  if (Array.isArray(value)) return value.map(String);
  if (typeof value === 'string') {
    if (value.startsWith('{')) {
      return value.replace(/^\{|\}$/g, '').split(',').filter(Boolean);
    }
    return value.length > 0 ? [value] : [];
  }
  return [];
}
